import Phaser from "phaser";
import { loadAssets } from "../textures";

/**
 * Loader scene. Preloads the Kenney 1-Bit spritesheet then hands off to
 * ArenaScene. Stays minimal — keep heavy work out of create() so future loading
 * screens can hook into the preload progress event cleanly.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super("BootScene");
  }

  preload(): void {
    loadAssets(this);
  }

  create(): void {
    this.scene.start("ArenaScene");
  }
}
